import { Component, OnInit, NgZone } from '@angular/core';
import { Platform } from '@ionic/angular';
import * as $ from 'jquery';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { ServiceService } from '../mastermodule/service/service.service';
import { Storage } from '@ionic/storage';
import { CookieService } from 'ngx-cookie-service';
import { App } from '@capacitor/app';
import { AlertController } from '@ionic/angular';
import { Subscription } from 'rxjs';
// import { process } from 'process';
@Component({
  selector: 'app-mastermodule',
  templateUrl: './mastermodule.page.html',
  styleUrls: ['./mastermodule.page.scss'],
})
export class MastermodulePage implements OnInit {
  key_session = '';
  user_id = '';
  user_type = '';

  stud_all_coursebatch_exam_result = [];
  stud_all_coursebatch_certificate_result = [];
  course_category_names = [];
  course_names = [];
  alert_exist: boolean = false;

  constructor(
    private alertController: AlertController,
    public platform: Platform,
    private cookies: CookieService,
    private storage: Storage,
    private api: ServiceService,
    private router: Router
  ) {
    this.key_session = this.api.get_session_id_login();

    this.user_id = this.api.localStorage.getItem('user_id');
    this.user_type = this.api.localStorage.getItem('user_type');

    if (this.key_session == '' || this.key_session == 'undefined') {
      this.router.navigate(['/mod0101']);
    }

    if (!this.api.backButtonSubscription) {
      this.api.backButtonSubscription =
        this.platform.backButton.subscribeWithPriority(10, () => {
          if (
            this.api.SplitUrl(window.location.href) == 'master' ||
            this.api.SplitUrl(window.location.href) == 'mod0101' ||
            this.api.SplitUrl(window.location.href) == 'pinlogin'
          ) {
            this.presentConfirmationAlert();
          } else {
            var back_url = this.api.platform_back_button_function(
              this.api.SplitUrl(window.location.href)
            );
            this.router.navigate([back_url]);
          }
        });
    }

    this.dummy_api_ony_for_verification()

  }

  ngOnInit() {
    this.api.setSharedData('Home');
  }

  async presentConfirmationAlert() {
    if (this.alert_exist == false) {
      this.alert_exist = true;
      const alert = await this.alertController.create({
        header: 'Confirmation',
        message: 'Are You Sure Want To Exit The App?',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'secondary',
            handler: () => {
              return;
            },
          },
          {
            text: 'OK',
            handler: () => {
              App.exitApp();
            },
          },
        ],
      });

      await alert.present();
      this.alert_exist = false;
    }
  }


  dummy_api_ony_for_verification()
  {
    this.api.call_http_post({
      url: environment.API_URL + 'mastermodule/dummy_api_ony_for_verification',
      data: {
      },
      modname:'',
      successCb: (res) => {
        var result = res.data;

      }
    });

  }

  
}
